export const TYPE_RADIO = 'radio';
export const TYPE_SELECT = 'select';
export const TYPE_TEXTAREA = 'textarea';
export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_NUMBER = 'number';
export const TYPE_VIZ = 'viz';
